export const styles = () => ({
  bgBlue: { background: '#E5F0FF' },
  container: { padding: 25 },
  employmentEndDate: { marginBottom: 25 },
  powerOnBtn: {
    background: '#01D38B',
    borderRadius: '50%',
    color: '#fff',
  },
  date: { opacity: '70%', fontWeight: 600 },
  powerOffBtn: { background: '#F41313', borderRadius: '50%', color: '#fff' },
  noticePeriod: { margin: '60px 0' },
  days: { opacity: '70%', marginLeft: 30 },
  saveBtnDiv: {
    height: 140,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  saveBtn: {
    color: '#fff',
    width: 330,
    height: 60,
    background: '#01D38B',
    borderRadius: 30,
    '&:hover': {
      background: '#01D38B',
      opacity: 0.8,
    },
  },
  warning: { color: '#F41313' },
  warningMsg: {
    color: '#F41313',
    display: 'flex',
    textAlign: 'center',
    margin: '25px 0',
  },
});
